import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import handleHospital from "@/services/modules/hospital";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => { 

    const { currencyToWord } = handlePurchase();
    const { onlyCommaFormat, commaFormat } = figureFormatter();
    const { calculateAge } = handleHospital();

    const exportToPDF = (company, invoice, barcode, qrcode, barcodePatient, userName, btnTitle, titleByType = false, isSalesMaster = false, isBillType = false, isRedirect = false, customizationFields = {}) => {
        const tableItems = invoice.has_item_detail ? invoice.general : invoice.ledgers;

        let margins = null;

        if(customizationFields['extra_settings_margin'] && customizationFields['extra_settings_margin'].is_active) {
            margins = customizationFields['extra_settings_margin'].value
        }

        var doc = {
            pageSize: 'A4',
            pageMargins: getPageMargin(margins),
            header: getHeader(company, customizationFields, margins, invoice),
            footer: getFooter(userName, qrcode, invoice, isRedirect, customizationFields, margins),
            content: getContent(invoice, tableItems, barcode, barcodePatient, userName, btnTitle, titleByType, isSalesMaster, customizationFields),

            styles : {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: invoice.bill_number
            }
        }

        pushIntoTable(doc, invoice, tableItems, btnTitle, isBillType, customizationFields)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getPageMargin = (margins) => {
        if(margins) {
            return [ margins.left, margins.top, margins.right, margins.bottom ]
        }

        return [ 60, 100, 60, 80 ];
    }

    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }

    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }

    function formatTimeOnly(dateTime) {
        if (!dateTime) return '';
        const date = new Date(dateTime);
        return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    }

    const getHeader = (company, customizationFields, margins, invoice) => {
        const showCoverPhoto = customizationFields['extra_settings_cover_photo_upload'] && customizationFields['extra_settings_cover_photo_upload'].is_active;
        
        if (showCoverPhoto) {
            return {
                columns: [
                    {
                        image: customizationFields['extra_settings_cover_photo_upload'].value64,
                        fit: [600, (margins && margins.top) ? margins.top : 120],
                        alignment: 'center',
                    }
                ]
            };
        }

        if(! showCoverPhoto && invoice.invoice_type === 'OPD Bill') {
            return;
        }

        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                shouldInclude(customizationFields,'heading_left_logo') && company.logo64
                    ? {
                        alignment: 'left',
                        image: company.logo64,
                        maxHeight: 60
                    }
                    : null,

                {
                    alignment: 'right',
                    stack: [
                        (shouldInclude(customizationFields,'heading_right_company_name') && company.name) ? company.name : '',
                        (shouldInclude(customizationFields,'heading_right_company_address') && company.address) ? 'Address: ' + company.address : '',
                        (shouldInclude(customizationFields,'heading_right_company_phone') && company.phone) ? 'Phone: ' + company.phone : '',
                        (shouldInclude(customizationFields,'heading_right_company_email') && company.email) ? 'E-mail: ' + company.email : '',
                        (shouldInclude(customizationFields,'heading_right_vat_reg_number') && company.vat_no) ? 'VAT Reg No: ' + company.vat_no : '',
                    ]
                }
            ]
        }
    }

    function shouldInclude(customizationFields, key) {
        return Object.keys(customizationFields).length === 0 || customizationFields[key];
    }

    const getContent = (invoice, tableItems, barcode, barcodePatient, userName, btnTitle, titleByType = false, isSalesMaster = false, customizationFields = {}) => {
        const getPatientDetails = (patient, fieldName) => {
            if (patient.profile_items) {
                const field = patient.profile_items.find(info => info.field === fieldName)
                return (field && field.value) ?? '';
            }
            return "";
        }

        const getReceiptTable = () => {
            if (
                (invoice.sale_master && invoice.sale_master.receipt_generals && invoice.receipt_generals.length > 0) ||
                invoice.receipt_generals && invoice.receipt_generals.length > 0
            ) {
                return {
                    table: {
                        widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        alignment: 'right',
                        body: getFooterTable(invoice, userName, isSalesMaster)
                    },

                    layout: {
                        hLineWidth: function (i, node) {
                            return 0.5;
                        },
                        vLineWidth: function (i, node) {
                            return 0.5;
                        },
                        fillColor: function (rowIndex, node, columnIndex) {
                            return (rowIndex === 0) ? '#f3f2f7' : null;
                        }
                    },

                    margin: [0, 10]
                }
            }
        }
        return  [
            {
                text: titleByType && invoice.hasOwnProperty('invoice_type') ? invoice.invoice_type : btnTitle,
                style: 'header',
                alignment: 'center',
                margin: [0, 5, 20, 0],
                bold: true,
                color: 'black',
            },

            {
                margin: [0, 10, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            (shouldInclude(customizationFields,'body_top_left_patient_barcode')) ? {
                                svg: barcodePatient
                            } : '',

                            (shouldInclude(customizationFields,'body_top_left_patient_id')) ?
                            {
                                text: `Patient ID: ${invoice.contact_profile && 
                                                    invoice.contact_profile.patient_id ? 
                                                    invoice.contact_profile.patient_id : invoice.contact.id}`,
                                alignment: 'left',
                                width: '50%'
                            } : '',

                           (shouldInclude(customizationFields,'body_top_left_patient_name')) ?
                            {
                                text: `Patient Name: ${invoice.contact.name.toUpperCase()}`,
                                alignment: 'left',
                                width: '50%'
                            } : '',

                           (shouldInclude(customizationFields,'body_top_left_age')) ?
                            {
                                text: `${invoice.contact.birthday ? ('Age: ' + calculateAge(invoice.contact.birthday, invoice.date) + ' | ' + 'Gender: '+ capitalize(invoice.contact.gender)) : ''}`,
                                alignment: 'left',
                                width: '50%'
                            } : '',

                           (shouldInclude(customizationFields,'body_top_left_patient_phone_no')) ?
                                   {
                                text: `Patient Phone No: ${getPatientDetails(invoice.contact, 'mobile_no')}`,
                                alignment: 'left',
                                width: '50%'
                             } : '',

                          (shouldInclude(customizationFields,'body_top_left_patient_address')) ?
                            {
                                text: `${invoice.contact.address ? 'Patient Address: ' + invoice.contact.address : ''}`,
                                alignment: 'left',
                                width: '50%'
                            } : '',

                          (shouldInclude(customizationFields,'body_top_left_referred_by')) ? {
                                  text: [
                                      {
                                          text: 'Ref. By: ',
                                          bold: true,
                                          margin: [0, 20, 10, 0]
                                      },

                                      {
                                          text: invoice.sale_type === 'investigation_invoice' ?
                                              (invoice.investigation_consultant ?? '') +
                                              (invoice.transport_reference && invoice.transport_reference.trim() !== '' ?
                                                  ` (${invoice.transport_reference})` : '') :
                                              (invoice.consultant ?? ''),
                                          alignment: 'left',
                                      }
                                  ]
                         } : [],
                        ]

                    },

                    {
                        alignment: 'right',
                        stack: [
                            (shouldInclude(customizationFields,'body_top_right_bill_barcode')) ?
                            {
                                svg: barcode
                            } : '',

                            (shouldInclude(customizationFields,'body_top_right_bill_date')) ?
                            {
                                text: [
                                    {
                                        text: 'BILL DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: formatToDdMmYy(invoice.date),
                                    }
                                 ]
                            } : '',

                            (shouldInclude(customizationFields,'body_top_right_bill_number')) ?
                                {
                                text: [
                                    {
                                        text: 'BILL NO: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: invoice.bill_number
                                    }
                                 ]
                            } : '',

                           (shouldInclude(customizationFields,'body_top_right_admission_no')) && invoice.ipd_register && invoice.ipd_register.admission_no ?
                                {
                                    text: [
                                        {
                                            text: 'Admission No: ',
                                            bold: true,
                                            margin: [0, 0, 10, 0]
                                        },

                                        {
                                            text: invoice.ipd_register.admission_no
                                        }
                                    ]
                                } : [],

                            (shouldInclude(customizationFields,'body_top_right_admission_date')) && invoice.ipd_register && invoice.ipd_register.admission_date ?
                                {
                                    text: [
                                        {
                                            text: 'Admission Date: ',
                                            bold: true,
                                            margin: [0, 0, 10, 0]
                                        },

                                        {
                                            text: invoice.ipd_register.admission_date
                                        }
                                    ]
                                } : [],
                            (shouldInclude(customizationFields,'body_top_right_bed_cabin_no')) && invoice.ipd_register && invoice.ipd_register.service_resource ?
                                {
                                    text: [
                                        {
                                            text: 'Bed/Cabin no: ',
                                            bold: true,
                                            margin: [0, 0, 10, 0]
                                        },

                                        {
                                            text: invoice.ipd_register.service_resource.name
                                        }
                                    ]
                                } : [],

                            (shouldInclude(customizationFields,'body_top_right_referred_doctor')) && invoice.referred_doctor ? {
                                text: [
                                    {
                                        text: 'Referred Doctor: ',
                                        bold: true,
                                        margin: [0, 20, 10, 0]
                                    },

                                    {
                                        text: invoice.referred_doctor
                                    }
                                 ]
                            } : [],

                            (shouldInclude(customizationFields,'body_top_right_consultant_name')) ? {
                                text: [
                                    {
                                        text: 'Consultant Name: ',
                                        bold: true,
                                        margin: [0, 20, 10, 0]
                                    },

                                    {
                                        text: invoice.sale_type === 'investigation_invoice' ?
                                            (invoice.investigation_consultant ?? '') +
                                            (invoice.transport_reference && invoice.transport_reference.trim() !== '' ?
                                                ` (${invoice.transport_reference})` : '') :
                                            (invoice.consultant ?? '')
                                    }
                                 ]
                            } : [],

                            (shouldInclude(customizationFields,'body_top_right_referrer_code')) && invoice.referrer_serial_no ?
                            {
                                text: [
                                    {
                                        text: 'Code: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: invoice.referrer_serial_no
                                    }
                                ]
                            } : [],
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: getTableWidth(btnTitle, tableItems, invoice, customizationFields),
                    body: []
                },
                layout: {
			        fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
		        }
		    },

            {
                columns: [
                    {
                        width: '65%',
                        stack: [
                            (shouldInclude(customizationFields,'body_bottom_in_words_amount')) ?
                            {
                                text: invoice.total_amount ? ('In Words: ' + currencyToWord(invoice.total_amount)) : ''
                            } : '',

                            {
                                margin: [15, 25],
                                fontSize: 14,
                                table: {
                                    body: [
                                        [{
                                         text:invoice.status !== 'returned' ? capitalize(invoice.payment_status) : capitalize(invoice.status), margin: [10, 5]
                                        }]
                                    ],
                                },
                                layout: {
                                    fillColor: '#f3f2f7'
                                }
                            },
                        ]
                    },
                     
                    {
                        table: {
                            widths: ['*', '*'],
                            alignment: 'right',
                            body: totalBodyData(invoice, customizationFields)
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return 0.5;
                            },
                            vLineWidth: function (i, node) {
                                return 0.5;
                            }
                        }
                    },
                ],
                margin: [0, 10]
            },

            {
                alignment: 'justify',
                text: [{ text: invoice.description ? 'NOTE: \n' : '', bold: true}, {text: invoice.description} ]
            },

            getReceiptTable()

        ]
    }

    const getTableWidth = (btnTitle, tableItems, invoice, customizationFields) => {
        const hasRoomNumber = tableItems.some(item =>
            invoice.has_item_detail && item.product && item.product.short_description
        );

        if (btnTitle != 'BILL') {
            return ['*', 'auto'];
        }

        const rowStructure = [];

        if (shouldInclude(customizationFields,'body_table_sl')){
            rowStructure.push('auto')
        }
        if (shouldInclude(customizationFields,'body_table_particulars')){
            rowStructure.push('*')
        }
        if (hasRoomNumber && shouldInclude(customizationFields,'body_table_room_number')){
            rowStructure.push('auto')
        }
        if (shouldInclude(customizationFields,'body_table_qty')){
            rowStructure.push('auto')
        }
        if (shouldInclude(customizationFields,'body_table_unit_price')){
            rowStructure.push('auto')
        }
        if (shouldInclude(customizationFields,'body_table_amount')){
            rowStructure.push('auto')
        }

        return rowStructure;
    }

    const totalBodyData = (invoice, customizationFields) => {
        const tableBody = [];
        if (shouldInclude(customizationFields,'body_totals_table_total_amount')) {
            tableBody.push ([
                  { text: 'Total Amount', alignment: 'right', bold: true },
                  { text: commaFormat(invoice.subtotal_amount.toFixed(2)), alignment: 'right' }
                ])
        }

        if (invoice.service_charge_amount && shouldInclude(customizationFields,'body_totals_table_service_charge')) {
            tableBody.push([
                { text: 'Service Charge', alignment: 'right', bold: true },
                { text: onlyCommaFormat(invoice.service_charge_amount.toFixed(2)), alignment: 'right' }
            ]);
        }

        if (invoice.vat_amount && shouldInclude(customizationFields,'body_totals_table_vat_amount')) {
            tableBody.push([
                { text: 'VAT', alignment: 'right', bold: true },
                { text: onlyCommaFormat(invoice.vat_amount.toFixed(2)), alignment: 'right' }
            ]);
        }

        if (totalDiscount(invoice) > 0 && shouldInclude(customizationFields,'body_totals_table_discount')){
            tableBody.push([
                { text: 'Discount', alignment: 'right', bold: true },
                { text: commaFormat(totalDiscount(invoice).toFixed(2)), alignment: 'right' }
            ]);
        }

        if (shouldInclude(customizationFields,'body_totals_table_net_bill_amount')) {
            tableBody.push(
                [{text: 'Net Bill Amount', alignment: 'right', bold: true}, {
                    text: totalNetBillAmount(invoice),
                    alignment: 'right'
                }],
            );
        }
        if (getAdjustmentAmount(invoice) > 0 && shouldInclude(customizationFields,'body_totals_table_adjust_amount')) {
            tableBody.push([
                { text: 'Adjust Amount', alignment: 'right', bold: true },
                { text: commaFormat(getAdjustmentAmount(invoice).toFixed(2)), alignment: 'right' }
            ]);
        }
        if (shouldInclude(customizationFields,'body_totals_table_paid_amount')) {
            tableBody.push(
                [{ text: 'Paid Amount', alignment: 'right', bold: true }, { text: commaFormat(invoice.paid_amount.toFixed(2)), alignment: 'right' }],
            );
        }
        if (shouldInclude(customizationFields,'body_totals_table_due_amount')) {
            tableBody.push(
                [{ text: 'Due', alignment: 'right', bold: true }, { text: totalDue(invoice), alignment: 'right' }]
            );
        }

        return tableBody;
    }

    const totalDue = (invoice) => {
        let  totalDiscount = invoice.receipt_generals.reduce((sum, item) => sum + (item.discount_amount ?? 0), 0);
        let totalDue = invoice.total_amount - (invoice.paid_amount + totalDiscount) - getAdjustmentAmount(invoice)
        return commaFormat(totalDue.toFixed(2))
    }

    const getAdjustmentAmount = (invoice) => {
        return invoice.adjusted_amount - invoice.discount;
    }

    const totalDiscount = (invoice) => {
        let  totalDiscount = invoice.receipt_generals.reduce((sum, item) => sum + (item.discount_amount ?? 0), 0);
        totalDiscount += invoice.total_discount;
        return totalDiscount;
    }

    const totalNetBillAmount = (invoice) => {
        let totalDiscount = invoice.receipt_generals.reduce((sum, item) => sum + (item.discount_amount ?? 0), 0);
        let totalAmount = invoice.total_amount - totalDiscount
        return commaFormat(totalAmount.toFixed(2))
    }

    const getFooterTable = (invoice, userName, isSalesMaster = false) => {
        let sale_master = invoice.sale_master ?? undefined;
        if (isSalesMaster) {
            sale_master = invoice;
        }
        return [
            [
                { text: 'MR Date & Time'},
                { text: 'MR No' },
                { text: 'Mode of payment' },
                { text: 'MoP Ref.' },
                { text: 'Receipt by' },
                { text: 'Receipt Amount', alignment: 'right' }
            ],

            ... moneyReceiptTable(sale_master,invoice)
        ]
    }

    const moneyReceiptTable = (sale_master, invoice) => {
        return  sale_master.receipt_generals
            .filter(receipt_general =>
                receipt_general.receipt_master.total_paid_amount !== 0 ||
                receipt_general.receipt_master.refund_amount !== 0
            )
            .map(receipt_general => {
                const paid = receipt_general.receipt_master.total_paid_amount ?? 0;
                const refund = receipt_general.receipt_master.refund_amount ?? 0;
                const amount = paid !== 0
                    ? paid
                    : refund !== 0
                        ? -refund
                        : 0;

                return [
                    {
                        text:
                            formatToDdMmYy(receipt_general.receipt_master.receipt_date) +
                            ' ' +
                            formatTimeOnly(receipt_general.receipt_master.created_at)
                    },
                    { text: receipt_general.receipt_master.voucher_no ?? '' },
                    { text: receipt_general.receipt_master.account_head?.name ?? '' },
                    { text: receipt_general.receipt_master.receipt_reference ?? '' },
                    { text: sale_master.receipt_by ?? '' },
                    {
                        text: onlyCommaFormat(amount),
                        alignment: 'right'
                    }
                ];
            }) ?? [];
    };

    const getFooter = (userName, qrcode, invoice, isRedirect, customizationFields, margins) =>{
        const showCoverPhoto = customizationFields['extra_settings_footer_photo_upload'] && customizationFields['extra_settings_footer_photo_upload'].is_active;

        if (showCoverPhoto) {
            return {
                columns: [
                    {
                        image: customizationFields['extra_settings_footer_photo_upload'].value64,
                        fit: [600, (margins && margins.bottom) ? margins.bottom : 120],
                        alignment: 'center',
                    }
                ]
            };
        }

        if(! showCoverPhoto && invoice.invoice_type == 'OPD Bill') {
            return;
        }

        const footerText = customizationFields['extra_settings_footer_note'] && customizationFields['extra_settings_footer_note'].is_active ?
            customizationFields['extra_settings_footer_note'].value : null;

        return {
            margin: [ 60, 0, 60, 0 ],
            columns: [
                {
                    columns: [
                        shouldInclude(customizationFields,'footer_qrcode') ? {
                            svg: qrcode
                        } : '',

                        footerText ?
                            {
                                width: '90%',
                                alignment: 'left',
                                margin: [5, 20, 0, 0],
                                fontSize: 8,
                                stack: [
                                    {
                                        text: footerText
                                    },

                                ]
                            } :  shouldInclude(customizationFields,'footer_note') ? (

                            invoice.invoice_type == "Pharmacy Bill" ?
                            {
                                width: '90%',
                                alignment: 'left',
                                margin: [5, 20, 0, 0],
                                fontSize: 8,
                                stack: [
                                    {
                                        text: "কাটাছেঁড়া ও মেমো ছাড়া ঔষধ ফেরত যোগ্য নহে। ভবিষ্যৎ অনুসন্ধানের জন্য নিজ দায়িত্বে সংরক্ষণ করুন। মেডিসিন Return/ফেরত এর সময় অবশ্যই ক্যাশ মেমো/Invoice সাথে নিয়ে আসবেন।"
                                    },

                                    {
                                        margin: [0, 10, 0, 0],
                                        text: 'N.B: This is a system generated documents and requires no manual signature.',
                                    }
                                ]
                            } :

                            {
                                width: '90%',
                                alignment: 'left',
                                fontSize: 8,
                                text: isRedirect ? "অনলাইনে রিপোর্ট পেতে QR স্ক্যান করুন" : 'N.B: This is a system generated documents and requires no manual signature.',
                                margin: [5, 53, 0, 0],
                            }) : ''

                    ]
                },

                shouldInclude(customizationFields,'footer_printed_by') ? {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                } : ''
            ]
        }
    }

    const capitalize = (text) => {
        if(!text || typeof text !== 'string') {
            return '';
        }

        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    const pushIntoTable = (doc, invoice, tableItems, btnTitle, isBillType, customizationFields) => {
        var flag = false;
        var isBill = false;

        const hasRoomNumber = tableItems.some(item =>
            invoice.has_item_detail && item.product && item.product.short_description
        );

        tableItems.forEach((item, index) => {
            if( !flag ){
                const tableHeader = getTableHeader(btnTitle, hasRoomNumber, customizationFields);
                doc.content[2].table.body.push(tableHeader);
                flag = true;
            }
            if( !isBill ){
                const rowData = getRowData(invoice, item, btnTitle, index, hasRoomNumber, customizationFields);
                isBill = isBillType
                return doc.content[2].table.body.push(rowData);
            }
        });
    }

    const getTableHeader = (btnTitle, hasRoomNumber, customizationFields) => {
        if (btnTitle !== 'BILL') {
            return [
                { text: 'Particulars' },
                { text: 'Amount', alignment: 'right' }
            ];
        }

        const header = [];
        if (shouldInclude(customizationFields,'body_table_sl')) {
            header.push({ text: 'SL' });
        }
        if (shouldInclude(customizationFields,'body_table_particulars')) {
            header.push({ text: 'Particulars' });
        }
        if (hasRoomNumber && shouldInclude(customizationFields,'body_table_room_number')) {
            header.push({ text: 'Room Number' });
        }
        if (shouldInclude(customizationFields,'body_table_qty')) {
            header.push({ text: 'Qty', alignment: 'right' });
        }
        if (shouldInclude(customizationFields,'body_table_unit_price')) {
            header.push({ text: 'Unit Price', alignment: 'right' });
        }
        if (shouldInclude(customizationFields,'body_table_amount')) {
            header.push({ text: 'Amount', alignment: 'right' });
        }

        return header;
    }
    const getRowData = (invoice, item, btnTitle, index, hasRoomNumber, customizationFields) => {
        let finaTotalAmount = item.total_amount
        if (!invoice.has_item_detail){
            finaTotalAmount = item.credit - item.discount_amount + item.vat_amount
        }

        if (btnTitle !== 'BILL') {
            return [
                { text: invoice.has_item_detail ? item.product.name : item.head.name },
                { text: onlyCommaFormat(item.amount), alignment: 'right' }
            ];
        }

        const row = [];
        if (shouldInclude(customizationFields,'body_table_sl')) {
            row.push({
                text: index + 1
            });
        }
        if (shouldInclude(customizationFields,'body_table_particulars')) {
            row.push({
                text: invoice.has_item_detail ? item.product.name : item.head.name
            });
        }
        if (hasRoomNumber && shouldInclude(customizationFields,'body_table_room_number')) {
            row.push({
                text: invoice.has_item_detail ? item.product.short_description : ''
            });
        }
        if (shouldInclude(customizationFields,'body_table_qty')) {
            row.push({
                text: item.quantity ? onlyCommaFormat(item.quantity) : '', alignment: 'right'
            });
        }
        if (shouldInclude(customizationFields,'body_table_unit_price')) {
            row.push({
                text: onlyCommaFormat(invoice.has_item_detail ? item.rate : 0), alignment: 'right'
            });
        }
        if (shouldInclude(customizationFields,'body_table_amount')) {
            row.push({
                text: onlyCommaFormat(item.total_amount), alignment: 'right'
            });
        }

        return row;
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
